import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { GetPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetPriceFragmentFragmentDoc';
import { getEuroFromCentValue } from '../../../../helpers/getEuroFromCentValue';

/* GraphQL */ `
  fragment GetPriceFragment on ProductPrice {
    value
    valueOld
  }
`;

export type GetPriceProps = FragmentType<typeof GetPriceFragmentFragmentDoc>;

export const getPrice = (data: GetPriceProps) => {
  const { value, valueOld } = getFragmentData(GetPriceFragmentFragmentDoc, data);

  const price = getEuroFromCentValue(value);

  return {
    price,
    oldPrice: valueOld ? getEuroFromCentValue(valueOld) : price,
  };
};
